export default __webpack_public_path__ + "static/media/personIcon.994e6fac.svg";